import { Document, Page, Text, View, StyleSheet} from '@react-pdf/renderer';


import {style} from '../../../components/pdf/fontstyles';
import {AutoText} from '../../../components/pdf/autoText'; 



const styles = StyleSheet.create({
     
          
          to: {
            fontSize: 10,
            marginBottom: 5, 
            textAlign: 'left',
          },
      
          table: {
            
            display: 'table',
            width: '100%',
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#000',
          },
          row: {
            flexDirection: 'row',
            borderBottom: '1px solid #000',
          },
          cell: {
            padding: 5,
            borderRight: '1px solid #000',
            verticalAlign: 'middle',
          },
          headerCell: {
            fontWeight: 'bold',
            backgroundColor: '#f2f2f2',
          },
          // Column specific styles (adjust widths for each column)
          srNoCell: {
            width: '5%', // First column with smaller width
          },
          detailsCell: {
            width: '55%', // Second column with larger width
          },
          pageNoCell: {
            width: '40%', // Third column with medium width
          },


          signature: {
            textAlign: 'right',     // to align text to the right
            marginTop: 30,          // optional: add some space on top
          },
          


        });


        
        
const FormBPart1 = ({ result }) => {


  const tableData = [
    ['1', 'Name (in block letters)', result.employeeName],
    ['2', 'Father’s / Husband’s Name ',  result.fatherName],
    ['3', 'Designation', result.designation],
    ['4', 'Name of Office / Department in which employed', result.institutionName],
    ['5', 'Date of Birth (by Christian era)', result.dateOfBirth],
    ['6', 'Date of retirement on Superannuation', result.dateOfRetirement],
    ['7', 'Fraction of Superannuation Pension', `40% of Pension i.e. Rs. ${result.commutedPension}/-`],
    [
      '8',
      `Desbursing authority from which pension is to be drawn after retirement
        a)Treasury/Sub-Treasury (Name and complete address of the Treasury/ Sub-Treasury to be indicated.)
        b)	(i) Branch of Nationalised Bank with complete postal address.
        (ii)   Bank Account number to which monthly pension is being credited each month.
        `,
        `${result.treasury}
        ${result.bankName}
        ${result.branchName}
        IFSC: ${result.ifscCode}
        Account No: ${result.accountNumber}`
    ],
  ];
  
  return (
              <View size="A4" style={style.page}> 
                <Text style={[style.title, style.ArialBlack, {marginBottom:10}]}>FORM - B</Text>
                <Text style={[style.subtitle, { fontSize: 8 },{marginBottom: 2}]}>[ See Rules 5(2), 12, 13, 14(1) and 15(3)]</Text>
                <Text style={[style.subtitle, { fontSize: 12 },{marginBottom: 2}]}>
                Form of application for commutation of a fraction of pension without medical examination.
                </Text>
                <View style={style.solidLine} />

                <Text style={[style.subtitle, { fontSize: 8 } ,{marginTop: 0}]}>(To be submitted in duplicate at least three months before the date of retirement)</Text>

                <Text style={[style.title, style.ArialBold, {marginBottom:5}]}>PART - I</Text>


                <View style={styles.to}>
                  <Text>To,</Text>
                  <Text>The Administrative Officer,</Text>
                  <Text>Higher Education Grant,</Text>
                  <Text >{result.region} Region, {result.city}.</Text>
                </View>

     
               
                <Text style={[styles.paragraph, { marginLeft: 30 }]}>
                Subject: Commutation of Pension without medical examination.
                </Text>

                <Text style={styles.bold}>Respected Sir,</Text>
              <View style={{marginLeft:10}}>
                <Text style={styles.paragraph}>I desire to commute a fraction of my pension as indicated below in accordance with provision contained in Maharashtra Civil Services (Commutation of Pensions) Rules 1981. The necessary particulars are furnished below.</Text>

               {/* Table */}
                   <View style={styles.table}>
                    
                     {/* Table Data */}
                     {tableData.map(([srNo, details, value], index) => (
                      <View style={styles.row} key={index}>
                        <Text style={[styles.cell, styles.srNoCell]}>{srNo}</Text>
                        <Text style={[styles.cell, styles.detailsCell]}>{details}</Text>
                        <AutoText style={[styles.cell, styles.pageNoCell]}>{value}</AutoText>
                      </View>
                    ))}
              </View>

              </View>
            

              <Text style={{ marginTop: 20 }}>Present Postal Address:</Text>
            
              <Text >{result.address}</Text>
              <Text >Postal address after Retirement  :</Text>
              <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
              <Text >{result.address}</Text>
              <AutoText style={[style.signature,{marginTop:0}] }>{result.employeeName}</AutoText>
              </View>


              <Text style={{ marginTop: 30 }}>Place: {result.placeOfRetirement}</Text>
            
                <Text style={{ marginTop: 10 }}>Date: </Text>
              
              </View>

);
};

export default FormBPart1;